











import { Component, Vue } from "vue-property-decorator";
import { SCREENSHOTENDPOINT } from "@/app.config";

@Component
export default class PlayerScreenshotPreview extends Vue {
    playerId = "";
    // lifecycle hooks

    // computed
    get screenshotSrc(): string {
        return `${SCREENSHOTENDPOINT}${this.playerId}`;
    }

    // methods
    open(playerId: string) {
        this.playerId = playerId;
        this.$bvModal.show("modal-playerScreenshotPreview");
    }

    hide() {
        this.$bvModal.hide("modal-playerScreenshotPreview");
    }
}
